import graphql__609273e87044ea3dd1d9 from "./__generated__/ParticipativeModuleResultsFormFieldBar_result.graphql.js";import { graphql, useFragment } from "react-relay";

import ParticipativeModuleResultsFormFieldContainer from "./ParticipativeModuleResultsFormFieldContainer";
import ParticipativeModuleResultsFormFieldChoicesChart from "./ParticipativeModuleResultsFormFieldChoicesChart";
import { barChartConfig } from "../../lib/charts/barChart";

const ParticipativeModuleResultsFormFieldBar = props => {
  const result = useFragment(ParticipativeModuleResultsFormFieldBar_result, props.result);

  return (
    <ParticipativeModuleResultsFormFieldContainer {...props} result={result}>
      <ParticipativeModuleResultsFormFieldChoicesChart
        result={result}
        config={barChartConfig}
      />
    </ParticipativeModuleResultsFormFieldContainer>
  );
};

const ParticipativeModuleResultsFormFieldBar_result = graphql__609273e87044ea3dd1d9;

export default ParticipativeModuleResultsFormFieldBar;
